import { render, staticRenderFns } from "./MarketSelector.vue?vue&type=template&id=29a92a58"
import script from "./MarketSelector.vue?vue&type=script&lang=ts"
export * from "./MarketSelector.vue?vue&type=script&lang=ts"
import style0 from "./MarketSelector.vue?vue&type=style&index=0&id=29a92a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports